<template>
  <div class="content">
    <div class="eve" v-for="item in imgs" :key="item.num" @click="go(item.num)" :style="item.style">
      <img :src="item.url" alt="" />
      <span>{{ item.tit }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgs: [
        { url: require("../../assets/1.png") ,tit:"智能防窃电系统",num:1,style:"box-shadow: ",path:"/production/fqd"},
        { url: require("../../assets/4.png") ,tit:"BMS蓄电池智能监测系统",num:2,style:"box-shadow: ",path:"/production/BMS"},
        { url: require("../../assets/2.png") ,tit:"智能远程抄表系统",num:3,style:"box-shadow: ",path:"/production/yccb"},
        { url: require("../../assets/6.png") ,tit:"蓄电池单体检测模块",num:5,style:"box-shadow: ",path:"/production/EBM"},
        // { url: require("../../assets/5.png") ,tit:"基站智能DCDU",num:6,style:"box-shadow: ",path:"/production/DCDU"},
        { url: require("../../assets/3.png") ,tit:"政府热线/政务服务便民热线",num:4,style:"box-shadow: ",path:"/production/hotline"},
      ],
    };
  },
  methods: {
    go(num) {
      console.log(num);
      this.imgs.forEach(item=>{
        if(num==item.num){
            this.$router.push(item.path)
        }else {
        }
      })
    },
  },
};
</script>
<style lang="less">
.content {
  width: 100%;
  height: 500px;
  //   border: 1px solid red;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  align-items: center;
  .eve {
    width: 28%;
    height: 200px;
    // border: 1px solid blue;
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      font-size: 20px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #333333;
    }
  }
  .eve:hover {
    box-shadow:5px 5px 5px 5px rgba(243, 245, 250)
  }
}
</style>